// @flow

import * as React from 'react';
import type { StageResult } from 'type/type';
import { formatedDuration } from 'services/format/formatDuration';

import StageIcon from '../../StageIcon/StageIcon';
import './TransitionStageResult.scss';

type Props = {
  result: StageResult,
  index: number
}

const RenderLogo = ({ index }: { index: number }) => (
  <StageIcon color="#0070d9" type={`T${index + 1}`} size="20px" wrapperClass="transition-stage-icon-wrapper" />
);

const TransitionStageResult = ({ result, index }: Props) => (
  <div className="transition-stage-result">
    <div className="transition-stage-result__logo-container">
      <RenderLogo index={index} />
    </div>
    <div className="transition-stage-result__split-time">
      {result && result.splitTime ? formatedDuration(result.splitTime) : '--'}
    </div>
  </div>
);

export default TransitionStageResult;
